var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.displayForm)?_c('button',{staticClass:"button view-primary-light",on:{"click":function($event){_vm.displayForm = true}}},[_vm._v("Hlasovat pro tento projekt")]):_vm._e(),_vm._v(" "),(_vm.displayForm)?_c('reconstruction-challenge-vote-form'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-128c1bf1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reconstruction-challenge/VoteContainer.vue
// module id = null
// module chunks = 